import Footer from 'app/components/FooterComponent';
import Header from 'app/components/HeaderComponent';
import HeaderImage from 'home/components/HeaderImage';
import Loader from '__common/components/LoaderComponent';
import React from 'react';
import { Alert, Box, Button, Divider, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { RESET_PASSWORD } from 'actions';

type Props = {
  dispatch: Function,
  resetPassword: resetPasswordState,
};

class ResetPassword extends React.Component<Props> {
  resetPasswordHandler = () => {
    const { dispatch } = this.props;
    dispatch(RESET_PASSWORD());
  }

  form() {
    return (
      <Box className="auth-card">
        <Typography variant="h4" className="glass-title">Reset Password</Typography>
        <Typography variant="body2" className="glass-subtitle">Confirm that you want to receive a password reset link.</Typography>
        <Divider className="glass-divider" sx={{ my: 3 }} />
        <Button variant="contained" type="button" className="form_button" id="login_button" fullWidth onClick={this.resetPasswordHandler}>
          Send Reset Link
        </Button>
        <Box className="glass-links"><Link to="/login" className="glass-link glass-link-primary">Back to sign in</Link></Box>
      </Box>
    );
  }

  successfullyReset = () => {
    return (
      <Box className="auth-card">
        <Typography variant="h4" className="glass-title">Check Your Email</Typography>
        <Divider className="glass-divider" sx={{ my: 3 }} />
        <Alert severity="success" className="auth-alert">We sent a reset link to your email address.</Alert>
        <Box className="glass-links"><Link to="/login" className="glass-link glass-link-primary">Back to sign in</Link></Box>
      </Box>
    );
  }

  content = () => {
    const { resetPassword: { error, sending, success } } = this.props;

    if (error) {
      return (
        <Box className="auth-card">
          <Typography variant="h4" className="glass-title">Reset Password</Typography>
          <Divider className="glass-divider" sx={{ my: 3 }} />
          <Alert severity="error" className="auth-alert">We could not reset your password. Please try again.</Alert>
          <Box className="glass-links"><Link to="/login" className="glass-link glass-link-primary">Back to sign in</Link></Box>
        </Box>
      );
    }

    if (sending) {
      return (<Loader />);
    }

    if (success) {
      return this.successfullyReset();
    }

    return this.form();
  }

  render() {
    return (
      <div className="app-content reset-password glass-login-page">
        <Header />
        <HeaderImage content={this.content()} />
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state: appState) {
  return {
    resetPassword: state.resetPassword,
  };
}

export default connect(mapStateToProps)(ResetPassword);
